export default function convertDateObjectToString (dateObj) {
  const dateString = dateObj.toISOString().substring(0, 10)
  return dateString
}